import auth0 from 'auth0-js'

import vuex from '@/store.js'

import httpClient from '@/services/http.js'
import xray from '@/services/xray-service.js'

const CLIENT_ID = 'afVMpKW7Se145bFNR57pfg1f3Q4dMT1h'
const AUTH0_DOMAIN = 'simplystudio.auth0.com'
const CALLBACK_URI = process.env.VUE_APP_AUTH0_CALLBACK_URI // 'http://localhost:8080/callback'
const LOGOUT_REDIRECT_URI = process.env.VUE_APP_AUTH0_LOGOUT_REDIRECT_URI // 'http://localhost:8080/login'

const localStorageLoggedInKey = 'loggedIn';

const webAuth = new auth0.WebAuth({
  domain: AUTH0_DOMAIN,
  redirectUri: CALLBACK_URI,
  clientID: CLIENT_ID,
  responseType: 'token id_token',
  scope: 'openid profile email',
  audience: 'https://app.simplystudio.com'
});

class AuthService  {
  // Starts the user login flow
  login(customState) {
    webAuth.authorize({
      appState: customState
    });
  }

  handleCallback() {
    return new Promise((resolve, reject) => {
      webAuth.parseHash((err, authResult) => {
        if (err) {
          // eslint-disable-next-line no-console
          console.log(err)
          reject(err);
        } else {
          this.localLogin(authResult);
          resolve(authResult.appState);
        }
      });
    });
  }

  localLogin(authResult) {
    const idToken = authResult.idToken;
    const profile = authResult.idTokenPayload;
    const tokenExpiry = new Date(profile.exp * 1000);

    localStorage.setItem(localStorageLoggedInKey, 'true');

    // console.dir(authResult)

    const user = { token: idToken, ...profile, tokenExpiry: tokenExpiry }
    vuex.commit('mutate', { prop: 'user', value: user })
    
    httpClient.defaults.headers.authorization = 'Bearer ' + authResult.accessToken
    
    // console.dir(authResult)
    // console.log('expires', authResult.expiresIn)
    let renewInMs = (authResult.expiresIn - 60)*1000
    setTimeout(() => { this.renewTokens() }, renewInMs)
    
    xray.logEvent({
      eventData: {
        action: 'auth:login'
      }
    })
  }

  renewTokens() {
    // if (localStorage.getItem(localStorageLoggedInKey) !== "true") {
    //   return reject("Not logged in");
    // }
    webAuth.checkSession({}, (err, authResult) => {
      if (err) {
        throw(err)
      } else {
        this.localLogin(authResult)
        // resolve(authResult)
      }
    });
    // return new Promise((resolve, reject) => {
      
    // });
  }

  logout() {
    localStorage.removeItem(localStorageLoggedInKey);
    vuex.commit('mutate', { prop: 'user', value: null })
    webAuth.logout({
      returnTo: LOGOUT_REDIRECT_URI
    });
  }

  isAuthenticated() {
    let user = vuex.getters.user
    return user && (Date.now() < user.tokenExpiry)
  }
}

export default new AuthService();
